import { ModalProvider } from '@leroy-merlin-br/backyard-react-ui'

import reactComponentLoader from 'scripts/react-component-loader'

import Header from 'reactSite/Header'

const HeaderWithModalProvider = props => (
  <ModalProvider>
    <Header {...props} />
  </ModalProvider>
)

reactComponentLoader(HeaderWithModalProvider, '[data-new-header]')
